export default {
  "IconButton": "_IconButton_erix6_1"
};import "ni:sha-256;3gFAS8qAXel0xWKKYFDn5hA6z6LSN6WZx6GUhJKdMS8";